module.exports = __webpack_public_path__ + "img/truck-head.cfbfcd5.png";